import { observer } from "mobx-react-lite";
import React, {
  useContext,
  useEffect,
  useLayoutEffect,
  useRef,
  useState,
} from "react";
import {
  Row,
  Nav,
  TabContent,
  TabPane,
  ButtonDropdown,
  DropdownToggle,
  DropdownMenu,
} from "reactstrap";
import { RootStoreContext } from "../../app/stores/rootStore";
import LaserButton from "../buttons/toolbar/LaserButton";
import PreferenzeButton from "../buttons/toolbar/PreferenzeButton";
import ArrowButton from "../buttons/toolbar/ArrowButton";
import PickToolButton from "../buttons/toolbar/PickToolButton";
import DoubleArrowButton from "../buttons/toolbar/DoubleArrowButton";
import LineaButton from "../buttons/toolbar/LineaButton";
import SquareButton from "../buttons/toolbar/SquareButton";
import TriangleButton from "../buttons/toolbar/TriangleButton";
import CircleButton from "../buttons/toolbar/CircleButton";
import TextButton from "../buttons/toolbar/TextButton";
import ImageInsertButton from "../buttons/toolbar/ImageInsertButton";
import EraseButton from "../buttons/toolbar/EraseButton";
import DeleteButton from "../buttons/toolbar/DeleteButton";
import UndoButton from "../buttons/toolbar/UndoButton";
import RestoreButton from "../buttons/toolbar/RestoreButton";
import PortareAvantiButton from "../buttons/toolbar/PortareAvantiButton";
import PortareDietroButton from "../buttons/toolbar/PortareDietroButton";
import SettingScreenButton from "../buttons/toolbar/SettingScreenButton";
import classNames from "classnames";
import SelectedScreensShortcutBar from "../screen/SelectedScreensShortcutBar";
import { useTranslation } from "react-i18next";
import { translationHookOptions } from "../../app/localization/localization";
import { IToolbarSelectorParams } from "../../app/models/toolbar";
import ScreenSettingModal from "../screen/ScreenSettingModal";
import NoteModalContainer from "../containers/NoteModalContainer";
import ToolbarTab from "./ToolbarTab";
import ToolbarFileTabPane from "./ToolbarFileTabPane";
import { DropdownPenBrushButton } from "../buttons/toolbar/DropdownPenBrushButton";
import { ToolbarStickyButton } from "./ToolbarStickyButton";

const GenericToolbar: React.FC<IToolbarSelectorParams> = ({
  items,
  languageSelectionConfig,
  contentConfig,
  isSidebarOpen,
  stickyButton,
}) => {
  const rootStore = useContext(RootStoreContext);
  const { loadToolbar, toolbar, isToShowEditTab, theme } =
    rootStore.commonStore;
  const { isToShowScreensTab, isToAShowOnairStickyButton } =
    rootStore.screensStore;
  const { activeTab, setActiveTab } = rootStore.playerStore;
  const {
    isArrowEnabled,
    isLineEnabled,
    isDoubleArrowEnabled,
    isCircleEnabled,
    isTriangleEnabled,
    isRectangleEnabled,
    isBrushEnabled,
    isPenEnabled,
    isZoomed,
  } = rootStore.zwibblerStore;

  const [width, setWidth] = useState(window.innerWidth);
  const [selectedTab, setSelectedTab] = useState("file");
  const [disegnaDropdownOpen, setDisegnaDropdownOpen] = useState(false);
  const [frecceDropdownOpen, setFrecceDropdownOpen] = useState(false);
  const [formeDropdownOpen, setFormeDropdownOpen] = useState(false);

  const targetRef = useRef<HTMLDivElement | null>(null);
  const refRowModifica = useRef<HTMLDivElement>(null);
  const [t] = useTranslation(["browse_page"], translationHookOptions);
  const totalButtonArray: number[] = Array.from(Array(14).keys());

  const updateWidth = React.useCallback(() => {
    if (targetRef.current) {
      setWidth(targetRef.current.offsetWidth);
    }
  }, [width]);

  let count = 0;
  const getCorrectId = () => {
    const myId = "modifica" + count;
    count++;
    return myId;
  };

  useEffect(() => {
    const contentId = contentConfig ? contentConfig.contentId : 0;
    loadToolbar(contentId).then().catch();
  }, [
    loadToolbar,
    // contentConfig, //fix bug NTMD-361
  ]);

  //use effect viene richiamato richiamato ad ogni resize, fare due use effect, in cui uno gestisce solo il resize, cancellare event listener a fine use effect.
  useEffect(() => {
    window.addEventListener("resize", updateWidth);

    //inizialmente targetRef è null quindi utilizzo window.innerWidth per impostare la width
    if (targetRef && targetRef.current) {
      let toolbarWidth = targetRef?.current.clientWidth - 75;
      document.documentElement.style.setProperty(
        "--toolbarWidth",
        `${String(toolbarWidth + "px")}`
      );
    } else {
      let toolbarWidth = window.innerWidth - 75 - (isSidebarOpen ? 88 : 0);
      document.documentElement.style.setProperty(
        "--toolbarWidth",
        `${String(toolbarWidth + "px")}`
      );
    }

    //////////////FORSE RISOLVE PROBLEMA TOOLBAR QUANDO GIRIAMO IPAD, PRESA DALL'ALTRO USE EFFECT, NON SICURO///////////////////
    if (element) {
      //calcolo quanti bottoni entrano nella toolbar
      buttonRender = Math.floor(element?.offsetWidth / 70);

      //se i bottoni che entrano nella toolbar sono minori dei bottoni totali(13) allora imposto la variabile ButtonOverflow true
      if (refRowModifica.current) {
        if (buttonRender < refRowModifica.current?.childNodes.length) {
          setButtonOverflow(true);
        } else {
          setButtonOverflow(false);
        }
      }

      //trasformo il numero in un array
      buttonArray = Array.from(Array(buttonRender).keys());
      setDisplayButton("block");

      //Serve quando usciamo dal documento lasciando la toolbar su un menu diverso da FILE(default)
      toggleTab(activeTab);
    }

    return () => {
      window.removeEventListener("resize", updateWidth);
    };
  }, [updateWidth, targetRef?.current?.clientWidth, targetRef]);

  const toggleForme = () => setFormeDropdownOpen(!formeDropdownOpen);
  const toggleDisegna = () => setDisegnaDropdownOpen(!disegnaDropdownOpen);
  const toggleFrecce = () => setFrecceDropdownOpen(!frecceDropdownOpen);

  const [buttonOverflow, setButtonOverflow] = useState(false);

  var [element, setElement] = useState(
    document.getElementById("customToolbarRow")
  );
  var buttonRender: number = 0;
  var buttonArray: number[] = [];

  const setDisplayButton = async (display: string) => {
    //ciclo buttonArray cioe i bottoni che sono visualizzati prima del click e gli imposto display none/block
    buttonArray.forEach((element) => {
      var selectedButton = document.getElementById(
        selectedTab + element.toString()
      );
      if (selectedButton) {
        selectedButton.style.display = display;
      }
    });
    //array con bottoni opposti, ossia quelli che non sono stati impostati
    const oppositeButtonArray = totalButtonArray.filter(
      (val) => buttonArray.indexOf(val) === -1
    );
    //li impostiamo all'opposto per essere sicuri che non vegano visualizzati bottoni sbagliati
    oppositeButtonArray.forEach((element) => {
      var selectedButton = document.getElementById(
        selectedTab + element.toString()
      );
      if (selectedButton) {
        if (display === "block") {
          selectedButton.style.display = "none";
        } else {
          selectedButton.style.display = "block";
        }
      }
    });
  };

  const buttonTop = async () => {
    //imposto i bottoni che si vedono prima del click display none
    await setDisplayButton("none");
    buttonArray = await Array.from(Array(buttonRender).keys());
    //creo un array utilizzando utilizzando buttonArray(quanti ne entrano), prendendoli da totalButtonArray
    buttonArray = buttonArray.filter((val) => totalButtonArray.includes(val));
    setDisplayButton("block");
  };

  const buttonBottom = async () => {
    await setDisplayButton("none");
    buttonArray = await Array.from(Array(buttonRender).keys());
    buttonArray = totalButtonArray.filter((val) => !buttonArray.includes(val));
    setDisplayButton("block");
  };

  useLayoutEffect(() => {
    //imposto Element in base a quale tab della toolbar abbiamo selezionato
    switch (activeTab) {
      case "2":
        setElement(document.getElementById("customToolbarRowModifica"));
        break;
      case "4":
        setElement(document.getElementById("customToolbarRowLavagna"));
        break;
    }

    if (element) {
      //calcolo quanti bottoni entrano nella toolbar
      buttonRender = Math.floor(element?.offsetWidth / 70);

      //se i bottoni che entrano nella toolbar sono minori dei bottoni totali(13) allora imposto la variabile ButtonOverflow true
      if (refRowModifica.current) {
        if (buttonRender < refRowModifica.current?.childNodes.length) {
          setButtonOverflow(true);
        } else {
          setButtonOverflow(false);
        }
      }

      //trasformo il numero in un array
      buttonArray = Array.from(Array(buttonRender).keys());
      setDisplayButton("block");

      //Serve quando usciamo dal documento lasciando la toolbar su un menu diverso da FILE(default)
      toggleTab(activeTab);
    }
    // CalcButton();
  }, [buttonArray, element?.offsetWidth, buttonRender, activeTab]);

  const toggleTab = (tab: string) => {
    setActiveTab(tab);
    switch (tab) {
      case "1":
        setSelectedTab("file");
        break;
      case "2":
        setSelectedTab("modifica");
        break;
      case "3":
        setSelectedTab("strumenti"); //non esiste
        break;
      case "4":
        setSelectedTab("lavagna"); //non esiste
        break;
      case "5":
        setSelectedTab("schermi");
        break;
    }
  };

  if (!toolbar) return <></>;
  const { tools } = toolbar;

  return (
    <>
      <div
        className={classNames(" w-100 toolbar", `${theme!.toolbarBackground}`)}
        ref={targetRef}
      >
        <Nav tabs className="customNavTabs">
          <ToolbarTab
            tabText={t("toolbar_tab_file")}
            isActive={activeTab === "1"}
            onClick={() => {
              toggleTab("1");
              buttonTop();
            }}
          />
          {isToShowEditTab && (
            <ToolbarTab
              tabText={t("toolbar_tab_edit")}
              isActive={activeTab === "2"}
              onClick={() => {
                toggleTab("2");
                buttonTop();
              }}
            />
          )}
          {isToShowScreensTab && (
            <ToolbarTab
              tabText={t("toolbar_tab_screen")}
              isActive={activeTab === "5"}
              onClick={() => {
                toggleTab("5");
                buttonTop();
              }}
            />
          )}
        </Nav>
        <div style={{ width: "100%", display: "flex"}}>
          <TabContent
            activeTab={activeTab}
            // className={classNames("pt-1", "d-inline-block", "tabWidth", "align-bottom")}
            className={classNames("pt-1", "d-inline-block", "width100", "align-bottom")}
          >
            <TabPane tabId="1" className="toolbarCell customTabPane">
              <ToolbarFileTabPane
                totalItems={items.length}
                languageSelectionConfig={languageSelectionConfig}
                contentConfig={contentConfig}
              />
            </TabPane>

            <TabPane tabId="2" className="toolbarCell customTabPane">
              <div className="row">
                <div
                  className="pb-0 row customToolbarRow col-11"
                  id="customToolbarRowModifica"
                  ref={refRowModifica}
                >
                  {/* PREFERENZE */}
                  {tools.settings && (
                    <div id={getCorrectId()} style={{ display: "none" }}>
                      <div className="d-inline-flex">
                        <div className="ml-0 divButton">
                          <PreferenzeButton />
                        </div>
                        <div className="verticalDivider ml-2"></div>
                      </div>
                    </div>
                  )}

                  {/* PICK */}
                  {tools.pick && (
                    <div
                      className="divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <PickToolButton />
                    </div>
                  )}

                  {/* LASER */}
                  {tools.laser && (
                    <div
                      className="divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <LaserButton />
                    </div>
                  )}

                  {/* DA FARE: CAMBIARE MENU A TENDINA IN BOTTONE SE SI HA UN SOLO ELEMENTO */}
                  <DropdownPenBrushButton
                    id={getCorrectId()}
                    isBrushEnabled={isBrushEnabled}
                    isPenEnabled={isPenEnabled}
                    isZoomed={isZoomed}
                  ></DropdownPenBrushButton>

                  {/* FRECCE */}
                  {tools.arrows && (
                    <ButtonDropdown
                      isOpen={frecceDropdownOpen}
                      toggle={toggleFrecce}
                      className=" transparentButton dropdownButton dropdownDiv"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <DropdownToggle
                        color="none"
                        className={classNames(
                          " transparentButton dropdownButton",
                          isArrowEnabled || isDoubleArrowEnabled || isLineEnabled
                            ? `${theme!.toolbarActiveIconColor}`
                            : `${theme!.toolbarIconColor}`
                        )}
                        disabled={isZoomed}
                      >
                        {isArrowEnabled ||
                        (!isDoubleArrowEnabled && !isLineEnabled) ? (
                          <i className="fas fa-long-arrow-alt-right iconToolbarButton"></i>
                        ) : null}
                        {isDoubleArrowEnabled ? (
                          <i className="fas fa-expand-alt iconToolbarButton"></i>
                        ) : null}
                        {isLineEnabled ? (
                          <i className="fas fa-slash iconToolbarButton"></i>
                        ) : null}
                        <i className="fas fa-sort-down"></i>
                        <h6 className="textToolbarButton mb-0">
                          {t("toolbar_arrows_dropdown")}
                        </h6>
                      </DropdownToggle>
                      <DropdownMenu
                        className={classNames(
                          "dropdownMenu",
                          `${theme!.toolbarBackground}`
                        )}
                      >
                        <div className="divButton">
                          <ArrowButton />
                        </div>
                        <div className="divButton mb-1">
                          <DoubleArrowButton />
                        </div>
                        <div className="divButton">
                          <LineaButton />
                        </div>
                      </DropdownMenu>
                    </ButtonDropdown>
                  )}

                  {/* FORME */}
                  {tools.shape && (
                    <ButtonDropdown
                      isOpen={formeDropdownOpen}
                      toggle={toggleForme}
                      className=" transparentButton dropdownButton dropdownDiv"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <DropdownToggle
                        color="none"
                        className={classNames(
                          " transparentButton dropdownButton",
                          isCircleEnabled ||
                            isRectangleEnabled ||
                            isTriangleEnabled
                            ? `${theme!.toolbarActiveIconColor}`
                            : `${theme!.toolbarIconColor}`
                        )}
                        disabled={isZoomed}
                      >
                        {isCircleEnabled ||
                        (!isRectangleEnabled && !isTriangleEnabled) ? (
                          <i className="far fa-circle iconToolbarButton"></i>
                        ) : null}
                        {isRectangleEnabled ? (
                          <i className="far fa-square iconToolbarButton"></i>
                        ) : null}
                        {isTriangleEnabled ? (
                          <i className="far fa-triangle iconToolbarButton"></i>
                        ) : null}

                        <i className="fas fa-sort-down"></i>
                        <h6 className="textToolbarButton mb-0">
                          {t("toolbar_shapes_dropdown")}
                        </h6>
                      </DropdownToggle>
                      <DropdownMenu
                        className={classNames(
                          "dropdownMenu",
                          `${theme!.toolbarBackground}`
                        )}
                      >
                        <div className="divButton">
                          <CircleButton />
                        </div>
                        <div className="divButton mb-1">
                          <SquareButton />
                        </div>
                        <div className="divButton">
                          <TriangleButton />
                        </div>
                      </DropdownMenu>
                    </ButtonDropdown>
                  )}

                  {/* TESTO */}
                  {tools.text && (
                    <div
                      className="divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <TextButton />
                    </div>
                  )}

                  {/* INSERIMENTO IMMAGINE */}
                  {tools.insertImg && (
                    <div
                      className="ml-2 divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <ImageInsertButton />
                    </div>
                  )}

                  {/* CANCELLA SINGOLO ELEMENTO */}
                  {tools.erase && (
                    <div
                      className="ml-2 divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <EraseButton />
                    </div>
                  )}

                  {/* CANCELLA TUTTA LA PAGINA */}
                  {tools.delete && (
                    <div
                      className="ml-2 divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <DeleteButton />
                    </div>
                  )}

                  {/* UNDO */}
                  {tools.undo && (
                    <div
                      className="ml-2 divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <UndoButton />
                    </div>
                  )}

                  {/* REDO */}
                  {tools.redo && (
                    <div
                      className="ml-2 divButton"
                      id={getCorrectId()}
                      style={{ display: "none" }}
                    >
                      <RestoreButton />
                    </div>
                  )}

                  {/* PORTARE AVANTI/INDIETRO */}
                  {tools.moveFwBack && (
                    <>
                      <div
                        className="ml-2 divButton"
                        id={getCorrectId()}
                        style={{ display: "none" }}
                      >
                        <PortareAvantiButton />
                      </div>
                      <div
                        className="ml-2 divButton"
                        id={getCorrectId()}
                        style={{ display: "none" }}
                      >
                        <PortareDietroButton />
                      </div>
                    </>
                  )}
                </div>

                {buttonOverflow ? (
                  <div className="ml-auto divScrollButton">
                    <Row>
                      <button
                        style={{marginTop:"23%"}}
                        className=" fas fa-circle fa-xs transparentScrollButton "
                        onClick={() => buttonTop()}
                      ></button>
                    </Row>
                    <Row>
                      <button
                        className=" fas fa-circle fa-xs  transparentScrollButton mt-3 "
                        onClick={() => buttonBottom()}
                      ></button>
                    </Row>
                  </div>
                ) : null}
              </div>
            </TabPane>

            <TabPane tabId="5" className="toolbarCell customTabPaneScreen">
              <div className="pb-1 row">
                <div className="ml-4 divButton">
                  <SettingScreenButton />
                </div>
                <div className="verticalDivider ml-2"></div>
                <SelectedScreensShortcutBar />
              </div>
            </TabPane>
          </TabContent>

          {((toolbar.canShare && stickyButton === "share") ||
            (isToAShowOnairStickyButton && stickyButton === "onair")) && (
            <ToolbarStickyButton type={stickyButton} />
          )}
        </div>
      </div>

      <ScreenSettingModal />
      <NoteModalContainer />
    </>
  );
};

export default observer(GenericToolbar);
